export const DEFAULT_DIRECT_BOOKING_COMMUNICATION_TEMPLATE =
  'Hi ${first_name},\n\n' +
  'https://gojitsu.com/schedule/${booking_id} \n\n' +
  'Please click the link for booking. \n' +
  'Please feel free to reach out to Our Dispatch team at 1-855-249-7447, if you have any questions. Thank you.\n' +
  '\n' +
  'Jitsu has ${num_of_route} routes available for tomorrow. \n' +
  'Delivery window time: 08:00AM - 07:00PM. \n' +
  'Please show up at the pick address by 6:00AM.';
